// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { NodeId, NodeIdT, verifyNodeId } from "./node-id";
import { QualifiedName, QualifiedNameT, verifyQualifiedName } from "./qualified-name";

/**
 * One hop of a relative browse path (a reference to follow + the target name).
 */
export class RelativePathElement implements flatbuffers.IUnpackableObject<RelativePathElementT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): RelativePathElement {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRelativePathElement(
    bb: flatbuffers.ByteBuffer,
    obj?: RelativePathElement,
  ): RelativePathElement {
    return (obj || new RelativePathElement()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsRelativePathElement(
    bb: flatbuffers.ByteBuffer,
    obj?: RelativePathElement,
  ): RelativePathElement {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new RelativePathElement()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * Reference type to follow. When absent, `HierarchicalReferences` is assumed.
   */
  referenceTypeId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Follow the reference in the inverse direction.
   */
  isInverse(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Include subtypes of the reference type.
   */
  includeSubtypes(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * Browse name of the target node for this hop.
   */
  targetName(obj?: QualifiedName): QualifiedName | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new QualifiedName()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startRelativePathElement(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addReferenceTypeId(
    builder: flatbuffers.Builder,
    referenceTypeIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, referenceTypeIdOffset, 0);
  }

  static addIsInverse(builder: flatbuffers.Builder, isInverse: boolean) {
    builder.addFieldInt8(1, +isInverse, +false);
  }

  static addIncludeSubtypes(builder: flatbuffers.Builder, includeSubtypes: boolean) {
    builder.addFieldInt8(2, +includeSubtypes, +true);
  }

  static addTargetName(builder: flatbuffers.Builder, targetNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, targetNameOffset, 0);
  }

  static endRelativePathElement(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 10); // target_name
    return offset;
  }

  unpack(): RelativePathElementT {
    return new RelativePathElementT(
      this.referenceTypeId() !== null ? this.referenceTypeId()!.unpack() : null,
      this.isInverse(),
      this.includeSubtypes(),
      this.targetName() !== null ? this.targetName()!.unpack() : null,
    );
  }

  unpackTo(_o: RelativePathElementT): void {
    _o.referenceTypeId = this.referenceTypeId() !== null ? this.referenceTypeId()!.unpack() : null;
    _o.isInverse = this.isInverse();
    _o.includeSubtypes = this.includeSubtypes();
    _o.targetName = this.targetName() !== null ? this.targetName()!.unpack() : null;
  }

  unpackFields(...fields: string[]): RelativePathElementT {
    const t = new RelativePathElementT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("reference_type_id")) {
      t.referenceTypeId = this.referenceTypeId() !== null ? this.referenceTypeId()!.unpack() : null;
    }
    if (fieldSet.has("is_inverse")) {
      t.isInverse = this.isInverse();
    }
    if (fieldSet.has("include_subtypes")) {
      t.includeSubtypes = this.includeSubtypes();
    }
    if (fieldSet.has("target_name")) {
      t.targetName = this.targetName() !== null ? this.targetName()!.unpack() : null;
    }
    return t;
  }
}

export class RelativePathElementT implements flatbuffers.IGeneratedObject {
  constructor(
    public referenceTypeId: NodeIdT | null = null,
    public isInverse: boolean = false,
    public includeSubtypes: boolean = true,
    public targetName: QualifiedNameT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.targetName === null || this.targetName === undefined) {
      throw new Error('Required field "target_name" is not set');
    }
    const referenceTypeId = this.referenceTypeId !== null ? this.referenceTypeId!.pack(builder) : 0;
    const targetName = this.targetName !== null ? this.targetName!.pack(builder) : 0;

    RelativePathElement.startRelativePathElement(builder);
    RelativePathElement.addReferenceTypeId(builder, referenceTypeId);
    RelativePathElement.addIsInverse(builder, this.isInverse);
    RelativePathElement.addIncludeSubtypes(builder, this.includeSubtypes);
    RelativePathElement.addTargetName(builder, targetName);

    return RelativePathElement.endRelativePathElement(builder);
  }

  clone(): RelativePathElementT {
    const obj = new RelativePathElementT();
    obj.referenceTypeId = this.referenceTypeId !== null ? this.referenceTypeId!.clone() : null;
    obj.isInverse = this.isInverse;
    obj.includeSubtypes = this.includeSubtypes;
    obj.targetName = this.targetName !== null ? this.targetName!.clone() : null;
    return obj;
  }

  equals(other: RelativePathElementT): boolean {
    if (this.referenceTypeId !== null && other.referenceTypeId !== null) {
      if (!this.referenceTypeId!.equals(other.referenceTypeId!)) return false;
    } else if (this.referenceTypeId !== other.referenceTypeId) return false;
    if (this.isInverse !== other.isInverse) return false;
    if (this.includeSubtypes !== other.includeSubtypes) return false;
    if (this.targetName !== null && other.targetName !== null) {
      if (!this.targetName!.equals(other.targetName!)) return false;
    } else if (this.targetName !== other.targetName) return false;
    return true;
  }
}

export function verifyRelativePathElement(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyQualifiedName(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "target_name");
  } finally {
    verifier.popDepth();
  }
}
